import React from 'react';

import { StatusService } from '../../services/status';

export class Status extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            statuses: {},
            color: StatusService.color(this.props.statusID)
        };

        if (this.props.errorMessage) {
            this.state.message = this.props.errorMessage.message;
        }

        if (!this.state.message) {
            this.state.message = this.props.thirdParty ? StatusService.getFriendlyThirdPartyMessage(this.props.statusID) : StatusService.getFriendlyProposalMessage(this.props.statusID);
        }
    }

    render() {
        return (
            <div style={Object.assign({ color: this.state.color }, this.props.style)} title={`${this.state.message} (${this.props.statusID})`}>
                {this.state.message}
                {this.props.includeID && (
                    <span>&nbsp;({this.props.statusID})</span>
                )}
            </div>
        )
    }
}
